import { updatePet } from "../../api/petService";
import { createPet } from "../../api/petService";

export const useSavePet = (successCallback) => {
    const update = async (id, data) => {
        try {
            const updatedPet = await updatePet(id, data);
            successCallback(updatedPet);
            return updatedPet;
        } catch (error) {
            console.error("Failed to update pet:", error);
            throw error;
        }
    };
    const create = async (data) => {
        try {
            const updatedPet = await createPet(data);
            successCallback(updatedPet);
            return updatedPet;
        } catch (error) {
            console.error("Failed to create pet:", error);
            throw error;
        }
    };

  return { update, create };
};